// @ts-nocheck
import * as types from '../types';

const initialState = {
    weightDrawer: {
        isVisible: false,
        logs: [],
        hasMore: false,
    },
    sports: {
        list: [],
        fetching: false,
        filters: {
            keyword: '',
        },
    },
    categories: {
        list: [],
        fetching: false,
        filters: {
            keyword: '',
            sportId: null,
        },
    },
    leagues: {
        list: [],
        fetching: false,
        filters: {
            keyword: '',
            sportId: null,
            categoryId: null,
        },
    },
    teams: {
        list: [],
        fetching: false,
        filters: {},
    },
};

const weight = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.WEIGHTS_SPORTS_CHANGED: {
            return {
                ...state,
                sports: {
                    ...state.sports,
                    list: payload,
                },
            };
        }
        case types.WEIGHTS_SPORTS_FETCHING: {
            return {
                ...state,
                sports: {
                    ...state.sports,
                    fetching: payload,
                },
            };
        }
        case types.WEIGHTS_SPORTS_FILTERS_CHANGED: {
            return {
                ...state,
                sports: {
                    ...state.sports,
                    filters: {
                        ...state.sports.filters,
                        ...payload,
                    },
                },
            };
        }
        case types.WEIGHTS_SPORTS_FILTERS_CLEARED: {
            return {
                ...state,
                sports: {
                    ...state.sports,
                    filters: initialState.sports.filters,
                },
            };
        }
        case types.WEIGHTS_CATEGORIES_CHANGED: {
            return {
                ...state,
                categories: {
                    ...state.categories,
                    list: payload,
                },
            };
        }
        case types.WEIGHTS_CATEGORIES_FETCHING: {
            return {
                ...state,
                categories: {
                    ...state.categories,
                    fetching: payload,
                },
            };
        }
        case types.WEIGHTS_CATEGORIES_FILTERS_CHANGED: {
            return {
                ...state,
                categories: {
                    ...state.categories,
                    filters: {
                        ...state.categories.filters,
                        ...payload,
                    },
                },
            };
        }
        case types.WEIGHTS_CATEGORIES_FILTERS_CLEARED: {
            return {
                ...state,
                categories: {
                    ...state.categories,
                    filters: initialState.categories.filters,
                },
            };
        }
        case types.WEIGHTS_LEAGUES_CHANGED: {
            return {
                ...state,
                leagues: {
                    ...state.leagues,
                    list: payload,
                },
            };
        }
        case types.WEIGHTS_LEAGUES_FETCHING: {
            return {
                ...state,
                leagues: {
                    ...state.leagues,
                    fetching: payload,
                },
            };
        }
        case types.WEIGHTS_LEAGUES_FILTERS_CHANGED: {
            return {
                ...state,
                leagues: {
                    ...state.leagues,
                    filters: {
                        ...state.leagues.filters,
                        ...payload,
                    },
                },
            };
        }
        case types.WEIGHTS_LEAGUES_FILTERS_CLEARED: {
            return {
                ...state,
                leagues: {
                    ...state.leagues,
                    filters: initialState.leagues.filters,
                },
            };
        }
        case types.WEIGHTS_TEAMS_CHANGED: {
            return {
                ...state,
                teams: {
                    ...state.teams,
                    list: payload,
                },
            };
        }
        case types.WEIGHTS_TEAMS_FETCHING: {
            return {
                ...state,
                teams: {
                    ...state.teams,
                    fetching: payload,
                },
            };
        }
        default:
            return state;
    }
};

export default weight;
